import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const Tutoradmin_CalendarSlice = createSlice({
  name: "Tutoradmin_CalendarSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    Tutoradmin_Calendar: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successTutoradmin_Calendar: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutoradmin_Calendar: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutoradmin_Calendar: (state) => {
      state.data = {};
    },
  },
});

export const {
  Tutoradmin_Calendar,
  failureTutoradmin_Calendar,
  successTutoradmin_Calendar,
  clearTutoradmin_Calendar,
} = Tutoradmin_CalendarSlice.actions;

export default Tutoradmin_CalendarSlice.reducer;
